module.exports = __webpack_public_path__ + "media/img/frontend_application/booking-banner-96274848ebfc463a212ed176c5c10a57.jpg";